const fakePlaid = {
  create: function (options) {
    return {
      open: () => {
        setTimeout(() => {
          options.onSuccess('fake-public-token', {
            account: { id: 'fake-account-id', mask: '1606' },
            institution: { name: 'Fake Bank' },
          });
        }, 50);
      },
    };
  },
};

export default fakePlaid;
